import React,{Fragment,useEffect, useState} from 'react'
import { apiwebUrl } from '../utils';

function Empleadolist() {
    const[empleado,setEmpleado]= useState([]);
    const traerServi = () =>{
        const url = apiwebUrl+"empleados.php"
        fetch(url).then( respuesta => respuesta.json())
        .then(data=>{
            setEmpleado(data)
        })
    }
    
    useEffect(() => {
       traerServi()
    }, [])
    
  return (
    <Fragment>
        <div className='d-flex justify-content-between flex-wrap' style={{width: '100%'}}>
           {empleado.map(item =>(
                <div className='col-3 border p-2 me-1 mb-2 w__full' key={item.idempleado}>
                    <img src={"https://servicios.campus.pe/fotos/"+item.foto} alt={item.nombres}  className="img-fluid"/>
                    <h4 className='text-center'>{item.nombres} {item.apellidos}</h4>
                    <p className='fw-bold'>Cargo: <span className='fw-light'>{item.cargo}</span></p>
                    <p className='fw-bold'>Telefono: <span className='fw-light'>{item.telefono}</span></p>
                </div>
           ))}
        </div>
    </Fragment>
  )
}

export default Empleadolist